import { chatbotHttp as api } from "./chatbotApi";

const base = (botId) => `/bots/${encodeURIComponent(botId)}/prescriptions`;
const unwrap = (response) => response.data?.data;

export const listPrescriptions = (botId, params = {}) =>
  api.get(base(botId), { params }).then(unwrap);
export const getPrescription = (botId, id) =>
  api.get(`${base(botId)}/${id}`).then(unwrap);
export const createPrescription = (botId, data) =>
  api.post(base(botId), data).then(unwrap);
export const updatePrescription = (botId, id, data) =>
  api.put(`${base(botId)}/${id}`, data).then(unwrap);
export const finalizePrescription = (botId, id) =>
  api.post(`${base(botId)}/${id}/finalize`).then(unwrap);
export const duplicatePrescription = (botId, id) =>
  api.post(`${base(botId)}/${id}/duplicate`).then(unwrap);
export const getPrescriptionPdf = (botId, id) =>
  api.get(`${base(botId)}/${id}/pdf`).then(unwrap);
export const listPrescriptionTemplates = (botId) =>
  api.get(`${base(botId)}/templates`).then(unwrap);
export const createPrescriptionTemplate = (botId, data) =>
  api.post(`${base(botId)}/templates`, data).then(unwrap);
export const updatePrescriptionTemplate = (botId, id, data) =>
  api.put(`${base(botId)}/templates/${id}`, data).then(unwrap);
export const publishPrescriptionTemplate = (botId, id) =>
  api.post(`${base(botId)}/templates/${id}/publish`).then(unwrap);
export const uploadPrescriptionTemplateLogo = (botId, id, file) => {
  const form = new FormData();
  form.append("upload", file);
  return api.post(`${base(botId)}/templates/${id}/logo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(unwrap);
};
export const duplicatePrescriptionTemplate = (botId, id) =>
  api.post(`${base(botId)}/templates/${id}/duplicate`).then(unwrap);
export const archivePrescriptionTemplate = (botId, id) =>
  api.post(`${base(botId)}/templates/${id}/archive`).then(unwrap);
export const searchPrescriptionCatalog = (botId, catalogType, q) =>
  api.get(`${base(botId)}/catalog`, { params: { catalog_type: catalogType, q } }).then(unwrap);
export const savePrescriptionCatalogItem = (botId, data) =>
  api.post(`${base(botId)}/catalog`, data).then(unwrap);
export const uploadPrescriptionAttachment = (botId, id, file, includeInPdf = false) => {
  const form = new FormData();
  form.append("upload", file);
  form.append("include_in_pdf", String(includeInPdf));
  return api.post(`${base(botId)}/${id}/attachments`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then(unwrap);
};
export const addPrescriptionAttachmentLink = (botId, id, data) =>
  api.post(`${base(botId)}/${id}/attachment-links`, data).then(unwrap);
export const getPrescriptionAttachment = (botId, id, attachmentId) =>
  api.get(`${base(botId)}/${id}/attachments/${attachmentId}`).then(unwrap);
export const sharePrescription = (botId, id, data) =>
  api.post(`${base(botId)}/${id}/share`, data).then(unwrap);
